class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videos = [];
    this.playButtons = [];
  }

  connectedCallback() {
    this.videos = Array.from(this.querySelectorAll('.footer-tiktok__video'));
    this.playButtons = Array.from(this.querySelectorAll('.footer-tiktok__play-btn'));

    this.playButtons.forEach((btn, index) => {
      const video = this.videos[index];

      btn.addEventListener('click', () => {
        this.pauseAllVideos();
        video.play();
        btn.style.display = 'none';
      });

      video.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          this.showPlayButtonFor(video);
        }
      });
    });

    this.videos.forEach(video => {
      video.volume = 0.1;
    });
  }

  pauseAllVideos() {
    this.videos.forEach((v, i) => {
      if (!v.paused) {
        v.pause();
        this.playButtons[i].style.display = '';
      }
    });
  }

  showPlayButtonFor(video) {
    const index = this.videos.indexOf(video);
    if (index !== -1) {
      this.playButtons[index].style.display = '';
    }
  }
}

customElements.define('video-player', VideoPlayer);
